import _ from 'lodash';
const state = {
   list: [],
   selected: ''
}

const mutations = {
   'CLIENTS_SET_LIST' (state, obj) {
      state.list = obj.client
   },
   'CLIENTS_REMOVE_CLIENT' (state, obj) {
      const index = _.findIndex(state.list, obj)
      state.list.splice(index, 1)
   },
   'CLIENTS_SET_CLIENT' (state, obj) {
      // const index = findIndex(state.list, { id: obj.user.id })
      // if (index > -1) {
      //     state.list.splice(index, 1)
      //     state.list.splice(index, 0, obj.user)
      // } else {
      //     state.list.unshift(obj.user)
      // }
   },
   'CLIENTS_SET_SELECTED' (state, obj) {
       if(!obj.client)
       return state.selected = {}

      state.selected = obj.client
   },
}

export default {
   state,
   mutations
}


// WEBPACK FOOTER //
// ./src/js/store/clients.module.js